module.exports = __webpack_public_path__ + "media/pdfs/construction_form-92cb568d.pdf";